module.exports = __webpack_public_path__ + "img/logo-footer.fdc10c5b.webp";